import { execute } from '../src/partialUpdate';

export const eshopUserToolsRefresh = () => {
	execute({
		target: 'userLists',
		url: `/qf/${window.projectConfig.lang}/ramjet/include`,
		updatedCart: true,
	});
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/eshopUserToolsRefresh.js